import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';

// Can now handle plain strings (with no links), or objects (with dynamic link)
export default function TagSection({ tags, clickable }) {
  if (isEmpty(tags)) return false;

  return (
    <div className="TagSection CarouselPanel__section">
      {tags.map(tag =>
        <React.Fragment key={tag.slug || tag}>
          {typeof tag === 'string' ?
            <div className="TagSection__tagColumn" key={tag}>
              <span className="TagSection__tag">{tag}</span>
            </div>
            :
            <div className="TagSection__tagColumn" key={tag.slug}>
              {tag.link && clickable ?
                <Link to={`/categories/${tag.slug}`} className="TagSection__tag">
                  {tag.name}
                </Link>
                :
                <span className="TagSection__tag">
                  {tag.name}
                </span>
              }
            </div>
          }
        </React.Fragment>,
      )}
    </div>
  );
}

TagSection.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])),
  clickable: PropTypes.bool,
};

TagSection.defaultProps = {
  tags: [],
  clickable: true,
};
